import React from 'react';
import { Button } from '@/components/atomics';
import styles from './ActionsConfirm.module.scss';
import Spinner from '@/components/atomics/Spinner';

type ActionsConfirmProps = {
  isLoading?: boolean;
  title: string;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
  confirmTitle?: string;
}

const className = 'actions-confirm';

const ActionsConfirm: React.FC<ActionsConfirmProps> = ({ confirmTitle, isLoading = false, 
  message, title, onConfirm, onCancel }) => {
  return (
    <div className={styles[isLoading ? className + '__loading' : className]}>
      {isLoading ? (
        <Spinner />
      ) : (
        <>
          <img height={110} src="/images/icon-warning.png" alt="warning" width={110} />
          <h5>{title}</h5>
          <p>{message}</p>
          <Button circle={true} variant="primary" onClick={onConfirm}>
            { confirmTitle ? confirmTitle : 'Ya' }
          </Button>
          <Button circle={true} variant="outline-primary" onClick={onCancel}>
            Batal
          </Button>
        </>
      )}
    </div>
  );
}

export default ActionsConfirm;
